<template>
	<div>
		<section>
			<el-form :model="formInline" :inline="true" label-width="80px">
				<el-form-item label="名称">
					<el-input disabled="" v-model="name" placeholder="输入名称" clearable=""></el-input>
				</el-form-item>
				<!-- 				<el-form-item label="公告分类">
					<el-input v-model="formInline.noticeType" placeholder="输入公告分类" clearable=""></el-input>
				</el-form-item> -->
			</el-form>
			<div id="wangEditor"></div>
			<!-- 			<div style="display: flex;margin: 20px 0;">
				<span style="color: #666666;margin-right: 10px;">上传附件</span>
				<el-upload action="/api/admin/notice/uploadNoticeFile" :on-success="successUpload" :multiple="true" name="file"
				 :file-list="newFiles" :on-remove="removeFile" list-type="text" :headers="headers">
					<el-button size="small" type="primary">点击上传</el-button>
				</el-upload>
			</div> -->
			<!-- <div>
				<el-checkbox v-model="checked" label="置顶"></el-checkbox>
				<el-checkbox v-model="checked" label="需要回执"></el-checkbox>
				<el-checkbox v-model="checked" label="是否弹出显示"></el-checkbox>
			</div> -->
			<!-- 	<div>
				<span>用户选择</span>
				<el-form :inline="true" :model="formInline">
					<el-form-item label="所属部门">
					 <el-select  v-model="formInline.deptName" placeholder="请选择活动区域">
					    <el-option v-for="s in memberTreeData" :label="s.deptName" :value="s.deptName"></el-option>		   
					  </el-select>
					  <el-select  v-model="formInline.roleId" placeholder="请选择部门">
					    <el-option  label="业主" :value="3"></el-option>		   
						<el-option  label="公寓委托方" :value="2"></el-option>	
					  </el-select>
					</el-form-item>
					<el-form-item label="用户名">
						<el-input v-model="formInline.username" placeholder="请输入用户名"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="getRequestAllMember">搜索</el-button>
					</el-form-item>
					<el-form-item>
						<el-button @click="clear">取消</el-button>
					</el-form-item>
					<el-form-item>
						<el-button @click="formData.checkAll=2">全选所有用户</el-button>
					</el-form-item>
				</el-form>
				
				<el-table @selection-change="handleSelectionChange" row-key="id" :data="memberTreeData" style="width: 100%">
					<el-table-column type="selection" :reserve-selection="true" width="55">
					</el-table-column>
					<el-table-column prop="deptName" label="所属部门">
					</el-table-column>
					<el-table-column prop="username" label="姓名">
					</el-table-column>
				</el-table>
				<el-pagination :current-page="formInline.currentPage" @current-change="handleCurrentChange" style="margin: 20px;0" background layout="total,prev, pager, next" :total="totalNum">
				</el-pagination>
				
			</div> -->
			<el-button v-if="cz == 2" style="margin-top: 30px;" @click="ok" type="primary">确认修改</el-button>
			<el-button style="margin-top: 30px; margin-left: 10px;" @click="goBack">返回</el-button>
		</section>
	</div>
</template>

<script>
let editor;
import wangEditor from 'wangeditor'

export default {
	data() {
		return {
			name: null,
			cz: null,
			content: null, id: null,
			formInline: {
				pageSize: 10,
				currentPage: 1,
				username: null,
				roleId: null,
				noticeTitle: "",
				noticeType: "",
			},
			totalNum: null,
			memberTreeData: [], //人员数据
			checked: ["置顶", "需要回执", "是否弹出显示"],
			newFiles: [],
			headers: { Authorization: localStorage.access_token },
			urls: [],
			receiverId: []
		}
	},
	mounted(val) {
		console.log(this.$route)
		this.cz = this.$route.params.cz
		this.id = this.$route.params.id
		this.name = this.$route.params.name
		this.content = this.$route.params.content

		// this.getRequestAllMember();
		// this.formInline1=JSON.parse(JSON.stringify(this.formInline))
		editor = new wangEditor('#wangEditor')
		editor.create()
		editor.txt.html(this.content)

	},
	methods: {
		getInfo() {


		},
		handleCurrentChange(val) {
			this.formInline.currentPage = val
			this.getRequestAllMember()
		},
		handleSelectionChange(val) {
			let id = []
			val.forEach(item => {
				id.push(item.id)
			})
			this.receiverId = id
		},
		getRequestAllMember() { //请求所有人员数据
			this.$http.post('/api/message/getAllUser', {
				...this.formInline
			}).then(res => {
				if (res.data.code == 0) {
					this.memberTreeData = res.data.data.items;
					this.totalNum = res.data.data.totalNum
				} else {

				}
			}, reject => {
				console.error('成员获取失败', reject.response.data.message);
			});
		},
		clear() {
			this.formInline = JSON.parse(JSON.stringify(this.formInline1))
			this.getRequestAllMember()
		},
		successUpload(res) {
			this.urls.push(res.data)
		},
		removeFile() {

		},
		ok() {
			// let top;
			// let receipt;
			// let eject;
			// this.checked.indexOf("置顶")==-1?top=1:top=2;
			// this.checked.indexOf("需要回执")==-1?receipt=1:receipt=2;
			// this.checked.indexOf("是否弹出显示")==-1?eject=1:eject=2;

			this.$http.post(`/api/manual/update`, {
				// name: this.name,		
				id: this.id,
				content: editor.txt.html(),
			}).then(res => {
				this.$message(res.data.message)
				// if(res.data.code==0){
				// 	this.$message.success("发送公告成功");
				// 	this.$router.go(-1)
				// }else {
				// 	this.$message.error("发送公告失败");
				// }
			})
		},
		goBack() {
			this.$router.go(-1)
		}
	},
}
</script>

<style scoped="scoped">
section {
	margin-top: 30px;
}

#wangEditor {
	width: 90%;
	/* height: 300px; */
}
</style>
